import React from "react"
import {
  Box,
  chakra,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from "@chakra-ui/react"
import { FormControl, SubmitButton, Input } from "@src/shared/components"
import { Formik } from "formik"
import * as Yup from "yup"
import axios from "axios"

interface InitialValues {
  firstName?: string
  email: string
}

const initialValues: InitialValues = {
  firstName: "",
  email: "",
}

const validationSchema = Yup.object({
  firstName: Yup.string().required("This field is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("This field is required"),
})

export const WailistListModal = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const SubmitAnswer = async (values: InitialValues) => {
    try {
      const resp = await axios.post("/api/waitlistEmail", values)
      console.log(resp.data)
      onClose()
    } catch (err) {
      // Handle Error Here
      console.error(err)
    }
  }
  return (
    <Box>
      <Box position="sticky" top="0">
        <Box bg="white" py={5} height="auto">
          <Button
            width="100%"
            mt={6}
            bg="#444444"
            _hover={{
              background: "#444444",
              color: "white",
            }}
            onClick={onOpen}
          >
            Join our waitlist
          </Button>
        </Box>
      </Box>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Join our waitlist</ModalHeader>
          <ModalCloseButton />
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={SubmitAnswer}
          >
            {({ handleSubmit }) => (
              <chakra.form onSubmit={handleSubmit}>
                <ModalBody>
                  <FormControl name="firstName">
                    <Input
                      size="lg"
                      placeholder="Enter your first name"
                      name="firstName"
                      label="First Name"
                    />
                  </FormControl>
                  <FormControl name="email" mt={4}>
                    <Input
                      size="lg"
                      placeholder="Enter your email"
                      name="email"
                      label="Email address"
                    />
                  </FormControl>
                </ModalBody>
                <ModalFooter>
                  <SubmitButton
                    bg="#444444"
                    _hover={{
                      background: "#444444",
                      color: "white",
                    }}
                  >
                    Submit
                  </SubmitButton>
                </ModalFooter>
              </chakra.form>
            )}
          </Formik>
        </ModalContent>
      </Modal>
    </Box>
  )
}
